import { createSlice } from "@reduxjs/toolkit";

import {
    getTrackerSettings,
    getTrackerSettingsAll,
    putTrackerSettings,
} from "./trackerSettings.asyncActions";

const initialState = {
    message: "",
    isLoading: false,
    isFailed: false,
    updateIsLoading: false,
    updateIsFailed: false,
    availableCodes: [],
    trackerCodes: [],
    error: null,
};

export const trackerSettingsSlice = createSlice({
    name: "trackerSettings",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTrackerSettingsAll.pending, (state) => {
                state.isLoading = true;
                state.isFailed = false;
            })
            .addCase(getTrackerSettingsAll.fulfilled, (state, action) => {
                state.isLoading = false;
                state.availableCodes = action.payload;
            })
            .addCase(getTrackerSettingsAll.rejected, (state) => {
                state.isLoading = false;
                state.isFailed = true;
            })

            .addCase(getTrackerSettings.pending, (state) => {
                state.isLoading = true;
                state.isFailed = false;
            })
            .addCase(getTrackerSettings.fulfilled, (state, action) => {
                state.isLoading = false;
                state.trackerCodes =
                    action.payload && action.payload.length > 0
                        ? action.payload[0].codes
                        : [];
            })
            .addCase(getTrackerSettings.rejected, (state) => {
                state.isLoading = false;
                state.isFailed = true;
            })

            .addCase(putTrackerSettings.pending, (state) => {
                state.updateIsLoading = true;
                state.updateIsFailed = false;
            })
            .addCase(putTrackerSettings.fulfilled, (state, action) => {
                state.updateIsLoading = false;
                state.message =
                    action.payload.message || "Settings updated successfully!";
            })
            .addCase(putTrackerSettings.rejected, (state) => {
                state.updateIsLoading = false;
                state.updateIsFailed = true;
            });
    },
});

export default trackerSettingsSlice.reducer;
